import * as pdfjsLib from 'pdfjs-dist';

// Configure the worker to use the CSP-compliant CDN worker matching the 3.11.174 version
pdfjsLib.GlobalWorkerOptions.workerSrc =
  'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

export { pdfjsLib };
